import { useContext } from "react";
import { Row, Col } from "reactstrap";

import { deleteServiceCity } from "../../../Services/ServiceCity.service";
import SharedDataContext from "../../../_helper/SharedData";
import { showAlert } from "../../../Services/Shared.service";

import { CommonModal } from "../../../AbstractElements";

const ServiceCityDeleteModal = ({
  Large,
  LargeModaltoggle,
  deleteObj,
  fetchData,
}) => {
  const { trgiggerRefresh } = useContext(SharedDataContext);

  const deleteCity = (id, isDeleted) => {
    deleteServiceCity(id, isDeleted ? false : true)
      .then(() => {
        fetchData();
        trgiggerRefresh();
        LargeModaltoggle();

        showAlert(
          "success",
          isDeleted
            ? "Service city recovered Successfully"
            : "Service city deleted Successfully"
        );
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response?.data?.message
            ? err.response.data.message
            : "Something went wrong"
        );
      });
  };

  const onDeleteSubmit = () => {
    if (deleteObj.id != null && deleteObj.isDeleted != null) {
      deleteCity(deleteObj.id, deleteObj.isDeleted);
    }
  };
  return (
    <CommonModal
      isOpen={Large}
      title={deleteObj.isDeleted ? "Recover" : "Delete"}
      toggler={LargeModaltoggle}
      size="md"
    >
      <Row className="driver-push-notification">
        <Col xl="12" className="push-botification-body">
          <div className="text-center">
            Do you want to {deleteObj.isDeleted ? "recover" : "delete"} this "
            {deleteObj.name}" service city ?
          </div>
        </Col>
        <Col xl="12" className="push-notification-footer">
          <button
            className="btn btn-primary"
            type="submit"
            onClick={() => onDeleteSubmit()}
          >
            Confirm
          </button>
        </Col>
      </Row>
    </CommonModal>
  );
};

export default ServiceCityDeleteModal;
